export enum PRIORITY_COLORS {
  DEFAULT = 1,
  YELLOW,
  RED,
  GREEN,
  PENDING,
}
